import React from 'react'
import { injectImpressionTag, removeImpressionTags } from '.'

export function useImpressionTags(tags: string[], deps: any[] = []) {
  React.useEffect(() => {
    tags.forEach((tag) => injectImpressionTag(tag))
    return () => removeImpressionTags()
  }, deps)
}
